import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../states/reducers';
import { updateBorrowerProfile } from '../../states/action_creators/profile.action_creator';
import { useCallback, useEffect } from 'react';
import { handleApiError } from '../../helpers';
import { fetchBorrowerProfileApi } from '../../apis/borrower';
import { Borrower } from '../../interfaces';
import { toast } from 'react-toastify';

export const useFetchBorrowerProfile = () => {
  const dispatch = useDispatch();
  const borrowerProfile = useSelector((state: RootState) => state.borrowerProfile);

  const fetchBorrowerProfile = useCallback(async () => {
    try {
      const response = await fetchBorrowerProfileApi();

      const data: Borrower = response.data;
      dispatch(updateBorrowerProfile(data));
    } catch (error) {
      toast.error(handleApiError(error));
    }
  }, [dispatch])

  useEffect(() => {
    fetchBorrowerProfile();
  }, [fetchBorrowerProfile]);
  return { profile: borrowerProfile.profile, fetchBorrowerProfile };
};
